import { ApprovalStatus } from '@data/course/approval/approval';
import React from 'react';

interface CourseApprovalMessageProps {
  approvalStatus: ApprovalStatus;
}

const CourseApprovalMessage: React.FC<CourseApprovalMessageProps> = ({ approvalStatus }) => {
  let text = '';

  switch (approvalStatus) {
    case ApprovalStatus.Approved:
      text = 'Approved';
      break;
    case ApprovalStatus.Flag:
      text = 'Approved With Flag';
      break;
    case ApprovalStatus.Denied:
      text = 'Denied';
      break;
    case ApprovalStatus.NoReview:
      text = 'No Review';
      break;
  }

  return <p className='text-xl text-center'>{text}</p>;
};

export default CourseApprovalMessage;
